import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { styled } from '@mui/material/styles';

import {
  Grid,
  Paper,
  TextField,
  Box,
  Skeleton,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
  FormGroup,
  Checkbox,
} from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import HrGradeSelectbox from '../common/form/selectbox/HrGradeSelectbox';
import HrDptSelectbox from '../common/form/selectbox/HrDptSelectbox';
import EmpFileUploadContainer from '../../containers/common/fileupload/EmpFileUploadContainer';

import UserRoleMultiCheckbox from '../common/form/checkbox/UserRoleMultiCheckbox';
import * as fileApi from '../../lib/api/file';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const authFilter = {
  blcCd: 'AUTH',
  mlcCd: 'USR',
  useYn: 'Y',
};

const EmployeeForm = ({ employee, formik }) => {
  const [entryDt, setEntryDt] = useState(null);
  const [profileImg, setProfileImg] = useState('');

  useEffect(() => {
    if (employee) {
      if (employee.entryDt) setEntryDt(employee.entryDt);
    }

    const loadProfileImage = async () => {
      try {        
        setProfileImg(await fileApi.profileImage(employee.profileImg));
      } catch (error) {
        console.error("이미지 호출 에러:", error);
      }
    };

    loadProfileImage();

    // 컴포넌트 언마운트 시 메모리 해제
    return () => {
      if (profileImg) URL.revokeObjectURL(profileImg);
    };

  }, [employee]);


  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangePrivilege = (item, isCheck) => {
    const old_list = [...formik.values.privilegeList];

    const newValue = {
      tgtUuid: employee?.usrUuid,
      tgtTyp: item?.slcCd,
      authTyp: item?.revVal2,
      authNm: item?.revVal1,
      authYn: isCheck ? 'Y' : 'N',
    };
    // 기존에 있는가? 있으면 업데이트, 없으면 추가.
    const findIndex = _.findIndex(
      old_list,
      (ol) => ol.authTyp === newValue?.authTyp,
    );
    //console.log(findIndex, 'findIndex');
    if (findIndex > -1) {
      old_list[findIndex] = { ...old_list[findIndex], ...newValue };
    } else {
      old_list.push(newValue);
    }

    formik.setFieldValue('privilegeList', old_list);

    //console.log(old_list, 'old_list');
  };

  return (
    <>
      <Paper
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          p: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={1}>
          {employee && (
            <Grid xs={3} item textAlign="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                {employee && employee.profileImg ? (
                  <Img
                    style={{
                      width: 200,
                      height: 170,
                    }}
                    alt={employee.usrNm}
                    src={profileImg}
                  />
                ) : (
                  <Skeleton
                    variant="rectangular"
                    width={200}
                    height={170}
                    animation={false}
                  />
                )}
              </Box>
              {/* <FileDropZone fileTyp="profile" fileAttrVal1={user.usrUuid} /> */}
              <EmpFileUploadContainer
                fileTyp="profile"
                fileAttrVal1={employee.usrUuid}
              />
            </Grid>
          )}
          <Grid
            item
            xs={employee ? 9 : 12}
            sx={{ flexGrow: 1 }}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={2}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNo"
                  name="usrNo"
                  label="사번"
                  value={formik.values.usrNo}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNo && Boolean(formik.errors.usrNo)}
                  helperText={formik.touched.usrNo && formik.errors.usrNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  label="이름"
                  value={formik.values.usrNm}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNm && Boolean(formik.errors.usrNm)}
                  helperText={formik.touched.usrNm && formik.errors.usrNm}
                />
              </Grid>
              <Grid item xs={4}>
                <HrDptSelectbox
                  formik={formik}
                  name="dptUuid"
                  label="부서"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3}>
                <HrGradeSelectbox
                  formik={formik}
                  name="gradeUuid"
                  label="직급"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {!employee && (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-password"
                    id="password"
                    name="password"
                    label="비밀번호"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-confirmPassword"
                    id="confirmPassword"
                    name="confirmPassword"
                    label="비밀번호 확인"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.confirmPassword &&
                      Boolean(formik.errors.confirmPassword)
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                  />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="telNo"
                  name="telNo"
                  label="연락처"
                  value={formik.values.telNo}
                  onChange={formik.handleChange}
                  error={formik.touched.telNo && Boolean(formik.errors.telNo)}
                  helperText={formik.touched.telNo && formik.errors.telNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="emlAddr"
                  name="emlAddr"
                  label="이메일"
                  value={formik.values.emlAddr}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.emlAddr && Boolean(formik.errors.emlAddr)
                  }
                  helperText={formik.touched.emlAddr && formik.errors.emlAddr}
                />
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider
                  dateAdapter={DateAdapter}
                  locale={koLocale}
                >
                  <DatePicker
                    label="입사일"
                    inputFormat={'yyyy-MM-dd'}
                    mask={'____-__-__'}
                    id="entryDt"
                    name="entryDt"
                    value={entryDt}
                    onChange={(newValue) => {
                      setEntryDt(newValue);
                      onChangeDate(newValue, 'entryDt');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        required
                        fullWidth
                        error={
                          formik.touched.entryDt &&
                          Boolean(formik.errors.entryDt)
                        }
                        helperText={
                          formik.touched.entryDt && formik.errors.entryDt
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <FormControl component="fieldset" sx={{ ml: 2 }}>
                  <FormLabel component="legend">성별</FormLabel>
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="row-radio-buttons-group"
                    value={formik.values.gender || 'F'}
                    onChange={(event) =>
                      formik.setFieldValue('gender', event.target.value)
                    }
                  >
                    <FormControlLabel
                      value="F"
                      control={<Radio />}
                      label="여성"
                    />
                    <FormControlLabel
                      value="M"
                      control={<Radio />}
                      label="남성"
                    />
                    {formik.touched.emlAddr &&
                      Boolean(formik.errors.gender) && (
                        <FormHelperText>{formik.errors.gender}</FormHelperText>
                      )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrNm"
                  name="postAddrNm"
                  label="우편번호"
                  value={formik.values.postAddrNm}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrNm &&
                    Boolean(formik.errors.postAddrNm)
                  }
                  helperText={
                    formik.touched.postAddrNm && formik.errors.postAddrNm
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrTxt"
                  name="postAddrTxt"
                  label="주소"
                  value={formik.values.postAddrTxt}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrTxt &&
                    Boolean(formik.errors.postAddrTxt)
                  }
                  helperText={
                    formik.touched.postAddrTxt && formik.errors.postAddrTxt
                  }
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={9}>
                <UserRoleMultiCheckbox
                  label="권한"
                  name="privilegeList"
                  checkedList={formik?.values?.privilegeList}
                  onChangeChecked={handleChangePrivilege}
                />
              </Grid>
              <Grid item xs={3}>
                <FormGroup>
                  <FormControlLabel
                    id="useYn"
                    name="useYn"
                    label="사용"
                    control={
                      <Checkbox
                        checked={formik.values.useYn}
                        //defaultChecked
                        onChange={(event) =>
                          formik.setFieldValue('useYn', event.target.checked)
                        }
                      />
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ px: 1 }}
          >
            <Grid item xs={12}>
              <TextField
                margin="normal"
                variant="outlined"
                fullWidth
                id="infoDesc"
                name="infoDesc"
                label="참고사항"
                multiline
                rows={5}
                value={formik.values.infoDesc}
                onChange={formik.handleChange}
                error={
                  formik.touched.infoDesc && Boolean(formik.errors.infoDesc)
                }
                helperText={formik.touched.infoDesc && formik.errors.infoDesc}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Paper>
    </>
  );
};

export default EmployeeForm;
